export default __webpack_public_path__ + "static/media/mic.c9c9788e.svg";